import React from 'react';
import { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { postApi } from "../../../../services/api/requestApi";

export default class ChangeMembership extends Component{

    constructor (props) {
        super (props);
        this.state = {
            id: props.id,
            showModal: props.showModal,
            setShowModal: props.setShowModal,
            currentMembership: props.currentMembership,
            newMembership: "Basic",
            reload: props.reload
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleClose = () => {
        this.state.setShowModal(false);
    }

    handleChange (e) {
        this.setState({newMembership: e.target.value});
    }

    handleSubmit = async() => {
        let url = '/api/user/update';
        let body = {
            'membership': this.state.newMembership
        }
        let response = await postApi(url, body);
        if (response !== false) {
            this.handleClose();
            this.state.reload();
        }
    }

    render () {
        return (
            <>
                <Modal animation={false} show={this.state.showModal} onHide={this.handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Change your Membership</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        
                            <div className="form-group">
                                <p>Your current membership is <b>{this.state.currentMembership}</b></p>
                            </div>
                            <div className="form-group">
                                <label>Choose your new Membership</label>
                                <select defaultValue={this.state.newMembership} onChange={this.handleChange} className="form-control">
                                    <option value="Basic">Basic</option>
                                    <option value="Premium">Premium</option>
                                </select>
                            </div>
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex">
                            <button className="btn btn-success mr-3" type="button"onClick={this.handleSubmit} >Confirm</button>
                            <button className="btn btn-danger" type="button" onClick={this.handleClose}>Abort</button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}